import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownAttachmentTypeContext } from "./form-dropdown-attachment-type.context";

export interface FormDropdownAttachmentTypeProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownAttachmentType<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownAttachmentTypeProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newAttachmentType,
    mappedAttachmentType,
    isCreating,
    setSidebar,
    setFilter,
    setNewAttachmentType,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownAttachmentTypeContext();
  
  return (
    <div className="attachment-type">
      {newAttachmentType && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new attachmentType</h2>
          <p>
            You are creating a new attachmentType. Please, fill the fields to create a
            new attachmentType and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="AttachmentType Name"
              value={newAttachmentType.name}
              onChange={(e: any) =>
                setNewAttachmentType({ ...newAttachmentType, name: e.target.value })
              }
            />
            <InputText
              placeholder="AttachmentType Description"
              value={newAttachmentType.description}
              onChange={(e: any) =>
                setNewAttachmentType({ ...newAttachmentType, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="AttachmentType"
        options={ mappedAttachmentType }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your attachmentType"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownAttachmentType;